import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';

export class SubscriptionsService {
  fetch() {
    return useCaller(RequestProxy.LS_AXON, RequestName.FETCH_SUBSCRIPTIONS, `subscription_types`, RequestMethod.GET);
  }
}
